export default "__VITE_ASSET__B6Qw13y0__"